//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'descripción',
        value: 'description',
    },
    {
        text: 'porcentaje',
        value: 'commPercentage',
    },
]
